import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl font-bold text-primary-500 whitespace-nowrap">
                蜜桃网站
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              专为年轻用户打造的甜蜜生活内容平台，涵盖时尚、美食、情感、生活方式等多元内容，让每一天都充满甜蜜与美好。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    <i className={`${cat.icon} mr-2 w-4 h-4 inline-flex items-center justify-center`}></i>
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  品牌口碑
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              关注我们
            </h4>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors" aria-label="微信公众号">
                <i className="ri-wechat-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors" aria-label="小红书">
                <i className="ri-red-packet-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors" aria-label="抖音">
                <i className="ri-tiktok-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>
            <p className="text-xs text-foreground-500 mt-4">
              联系邮箱：hello@mitao.readdy.ai
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2025 蜜桃网站 版权所有 | 甜蜜生活，从这里开始
          </p>
          <div className="flex gap-4 text-xs text-foreground-500">
            <a href="#" className="hover:text-primary-500 transition-colors">用户协议</a>
            <a href="#" className="hover:text-primary-500 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-primary-500 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}